import React, { useState } from "react";
import axios from "axios";
import { Loader2, KeyRound, Mail, Info } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useToast } from "../../hooks/use-toast";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Settings({ token, onToken }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const save = async (e) => {
    e.preventDefault();
    if (nw !== confirm) { toast({ title: "Passwords don't match" }); return; }
    if (nw.length < 6) { toast({ title: "New password must be at least 6 characters" }); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/change-password`, { current: cur, new: nw }, { headers: { "X-Admin-Token": token } });
      onToken(res.data.token);
      setCur(""); setNw(""); setConfirm("");
      toast({ title: "Password updated", description: "Your new password is now active." });
    } catch (err) {
      toast({ title: "Update failed", description: err?.response?.data?.detail || "Please try again." });
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-xl space-y-6">
      <form onSubmit={save} className="rounded-2xl bg-white p-6 ring-1 ring-brand-mist shadow-card">
        <div className="flex items-center gap-2 mb-1"><KeyRound className="h-5 w-5 text-brand-ocean" /><h3 className="font-heading font-extrabold text-brand-navy text-lg">Change Password</h3></div>
        <p className="text-sm text-brand-slate mb-5">Update the password used to access this dashboard.</p>
        <div className="space-y-4">
          <div><Label className="font-semibold text-brand-navy">Current Password</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1.5 h-11" /></div>
          <div><Label className="font-semibold text-brand-navy">New Password</Label><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} className="mt-1.5 h-11" /></div>
          <div><Label className="font-semibold text-brand-navy">Confirm New Password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-11" /></div>
        </div>
        <Button type="submit" disabled={loading || !cur || !nw} className="mt-5 h-11 px-6 bg-brand-ocean hover:bg-brand-sky text-white font-heading font-bold">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Update Password"}
        </Button>
      </form>

      <div className="rounded-2xl bg-white p-6 ring-1 ring-brand-mist shadow-card">
        <div className="flex items-center gap-2 mb-3"><Mail className="h-5 w-5 text-brand-ocean" /><h3 className="font-heading font-extrabold text-brand-navy text-lg">Notifications</h3></div>
        <p className="text-sm text-brand-slate">New Contact & Estimate submissions are emailed to:</p>
        <p className="mt-1 font-heading font-bold text-brand-navy">Info@millermillerservices.com</p>
        <div className="mt-4 flex items-start gap-2 text-xs text-brand-slate bg-brand-mist/60 rounded-lg p-3">
          <Info className="h-4 w-4 shrink-0 mt-0.5" />
          <span>To change the notification email, update OWNER_EMAIL in the backend environment.</span>
        </div>
      </div>
    </div>
  );
}
